<template>
  <div class="col-md-4 offset-md-1">
    <bloc-header-title sous-titre="Mes clients" :icone="['fas', 'user-tie']">
      <b-button id="show-btn" @click="showAddModal" variant="outline-primary"
        ><font-awesome-icon :icon="['fas', 'user-plus']" />Nouveau
        Client</b-button
      >
    </bloc-header-title>
    <bloc-listing
      :datas="clientList"
      @deletedElement="getClientList"
      @modalEdition="handleModalEdition"
    >
    </bloc-listing>
    <div>
      <creation-modal
        class="base-modal"
        :title="isEditMode ? 'Edition client' : 'Nouveau Client'"
        id="addClient"
        ref="creationModalComponent"
      >
        <b-form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <b-form-group id="type-group" label="Type" label-for="type-input">
                <b-form-select
                  id="type-input"
                  v-model="selected"
                  :options="typeOptions"
                  @change="handleChange"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="nom-client-group"
                label="Nom"
                label-for="nom-client-input"
              >
                <b-form-input
                  v-model="form.nom"
                  id="nom-client-input"
                  type="text"
                  required
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="adresse-client-group"
                label="Adresse"
                label-for="adresse-client-input"
              >
                <b-form-input
                  v-model="form.adresse"
                  id="adresse-client-input"
                  type="text"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="complementAdresse-client-group"
                label="Complément d' adresse"
                label-for="complementAdresse-client-input"
              >
                <b-form-input
                  v-model="form.complementAdresse"
                  id="complementAdresse-client-input"
                  type="text"
                >
                </b-form-input>
              </b-form-group>
              <div class="row">
                <b-form-group
                  id="code-postal-group"
                  label="Code postal"
                  label-for="code-postal-input"
                  class="col-md-3"
                >
                  <b-form-input
                    v-model="form.codePostal"
                    id="code-postal-input"
                    type="number"
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group
                  id="ville-group"
                  label="Ville"
                  label-for="ville-input"
                  class="col-md-9"
                >
                  <b-form-input
                    v-model="form.ville"
                    id="ville-input"
                    type="text"
                  >
                  </b-form-input>
                </b-form-group>
              </div>
              <b-form-group id="pays-group" label="Pays" label-for="pays-input">
                <b-form-input v-model="form.pays" id="pays-input" type="text">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                id="nom-contact-group"
                label="Nom du contact"
                label-for="nom-contact-input"
              >
                <b-form-input
                  v-model="form.contactNom"
                  id="nom-contact-input"
                  type="text"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="prenom-contact-group"
                label="Prenom du contact"
                label-for="prenom-contact-input"
              >
                <b-form-input
                  v-model="form.contactPrenom"
                  id="prenom-contact-input"
                  type="text"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="tel1-contact-group"
                label="Téléphone"
                label-for="tel1-contact-input"
              >
                <b-form-input
                  v-model="form.contactTel1"
                  id="tel1-contact-input"
                  type="text"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="tel2-contact-group"
                label="Mobile"
                label-for="tel2-contact-input"
              >
                <b-form-input
                  v-model="form.contactTel2"
                  id="tel2-contact-input"
                  type="text"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="email1-contact-group"
                label="Email 1 du contact"
                label-for="email1-contact-input"
              >
                <b-form-input
                  v-model="form.email1"
                  id="email1-contact-input"
                  type="email"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="email2-contact-group"
                label="Email 2 du contact"
                label-for="email2-contact-input"
              >
                <b-form-input
                  v-model="form.email2"
                  id="email2-contact-input"
                  type="email"
                >
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <div>
            <div class="button-wrap d-flex justify-content-end">
              <b-button variant="outline-primary">Annuler</b-button>
              <b-button
                v-if="!isEditMode"
                type="submit"
                variant="primary"
                class="lg-btn"
                >Valider</b-button
              >
              <b-button
                v-if="isEditMode"
                type="submit"
                variant="primary"
                class="lg-btn"
                >Modifier</b-button
              >
            </div>
          </div>
        </b-form>
      </creation-modal>
    </div>
  </div>
</template>
<script>
import CreationModal from '../utils/creationModal'
import BlocHeaderTitle from '../utils/blocHeaderTitle'
import BlocListing from '../utils/blocListing'
import ListingProjet from '../listProjet'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    listingProjet: ListingProjet,
    creationModal: CreationModal,
    blocHeaderTitle: BlocHeaderTitle,
    blocListing: BlocListing
  },
  data () {
    return {
      selected: 1,
      typeOptions: [
        { value: 1, text: 'Privé' },
        { value: 2, text: 'Collectivité' },
        { value: 3, text: 'SEM' },
        { value: 4, text: 'Etat' },
        { value: 5, text: 'EPS' },
        { value: 6, text: 'EPMS' },
        { value: 7, text: 'Particulier' },
        { value: 8, text: 'Autre' }
      ],
      form: {
        nom: '',
        contactNom: '',
        contactPrenom: '',
        contactTel1: '',
        contactTel2: '',
        email1: '',
        email2: '',
        adresse: '',
        complementAdresse: '',
        codePostal: 0,
        ville: '',
        pays: '',
        societe: this.userSocieteId(),
        typeClient: 1
      },
      clientList: [],
      showAllLink: false,
      isEditMode: false,
      clientId: 0

    }
  },
  mounted () {
    this.getClientList()
  },
  methods: {
    ...mapActions(['addAdminClient', 'listAdminClient', 'getAdminClient', 'updateAdminClient']),
    ...mapGetters(['userSocieteId']),
    handleChange (e) {
      this.form.typeClient = e
    },
    showAddModal () {
      this.isEditMode = false
      this.form = {
        nom: '',
        contactNom: '',
        contactPrenom: '',
        contactTel1: '',
        contactTel2: '',
        email1: '',
        email2: '',
        adresse: '',
        complementAdresse: '',
        codePostal: 0,
        ville: '',
        pays: '',
        societe: this.userSocieteId(),
        typeClient: 1
      }

      this.showModal()
    },
    showModal () {
      this.$refs.creationModalComponent.openModal()
    },
    hideModal () {
      this.$refs.creationModalComponent.closeModal()
    },
    handleSubmit () {
      if (this.isEditMode) {
        this.updateAdminClient({ id: this.clientId, data: this.form }).then((resp) => {
          this.$toaster.success('Client modifié avec succès')
          this.hideModal()
          this.getClientList()
        }, (err) => {
          this.$toaster.error(err)
        })

        return
      }
      this.addAdminClient(this.form).then((resp) => {
        this.$toaster.success('Client ajouté avec succès')
        this.hideModal()
        this.getClientList()
      }, (err) => {
        this.$toaster.error(err)
      })
    },
    handleRefreshList (datas) {
      this.clientList = datas
    },
    handleModalEdition (id) {
      this.getAdminClient(id).then((resp) => {
        this.clientId = resp.id
        let type = this.form.typeClient
        this.form = resp
        delete this.form.societeId
        delete this.form.societeNom
        this.form.societe = this.userSocieteId()
        this.form.typeClient = type
        this.showModal()
        this.isEditMode = true
      })
    },
    getClientList () {
      this.listAdminClient({ data: this.form.societe, page: 0 }).then((resp) => {
        this.clientList = resp.items
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.left-padding {
  padding-left: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/listingClients/index.vue